/* Runtime du clone advertorial — remplace les scripts du concurrent (retirés au build).
   Tout est scopé sous .tc-clone. Aucune dépendance externe. */
(function () {
  var root = document.querySelector('.tc-clone');
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ------------------------------------------------- révélation au scroll
     Le thème du concurrent masque .animate-item (opacity:0) tant que son JS
     n'a pas posé .animate--shown. Sans ce JS, la moitié de l'article reste
     invisible → on rejoue la même mécanique à l'IntersectionObserver.       */
  function initReveal() {
    var sections = $$('.animate-section');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) {
        s.classList.remove('animate--hidden');
        s.classList.add('animate--shown');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove('animate--hidden');
        e.target.classList.add('animate--shown');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    sections.forEach(function (s) { io.observe(s); });
  }

  /* ---------------------------------------------------------- carrousels */
  function initSplide() {
    $$('.splide').forEach(function (sp) {
      var track = $('.splide__track', sp);
      var list = $('.splide__list', sp);
      if (!track || !list) return;

      // les clones de boucle feraient doublon sans le JS de Splide
      $$('.splide__slide--clone', sp).forEach(function (c) { c.remove(); });
      var slides = $$('.splide__slide', sp);
      if (!slides.length) return;

      list.style.transform = 'none';
      list.style.display = 'flex';
      list.style.width = 'auto';
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.style.scrollBehavior = 'smooth';
      track.style.scrollbarWidth = 'none';
      // cartes d'avis de hauteur égale : le CSS du concurrent gagne sur nos
      // règles, on force l'étirement en inline
      list.style.alignItems = 'stretch';
      slides.forEach(function (s) {
        s.style.scrollSnapAlign = 'start';
        s.style.flex = '0 0 auto';
        s.style.display = 'flex';
        var box = s.querySelector('.splide__slide__container');
        if (box) { box.style.display = 'flex'; box.style.flexDirection = 'column'; box.style.width = '100%'; }
      });

      var step = function () { return slides[0].getBoundingClientRect().width + 16; };
      var prev = $('.splide__arrow--prev', sp);
      var next = $('.splide__arrow--next', sp);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollLeft += step(); });

      var dots = $$('.splide__pagination__page', sp);
      dots.forEach(function (d, i) {
        d.addEventListener('click', function (e) {
          e.preventDefault();
          if (slides[i]) track.scrollLeft = slides[i].offsetLeft - slides[0].offsetLeft;
        });
      });
      if (dots.length) {
        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / step());
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }
    });
  }

  /* ----------------------------------------------------- compte à rebours
     Même deadline pour les 3 blocs d'offre, gardée en sessionStorage pour
     qu'elle ne se réinitialise pas à chaque scroll/navigation interne.      */
  var COUNTDOWN_MS = 3 * 60 * 60 * 1000; // 3 h

  function initCountdown() {
    var boxes = $$('.timer-container');
    if (!boxes.length) return;
    var key = 'tc_adv_lumea_gel_deadline';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + COUNTDOWN_MS;
      sessionStorage.setItem(key, String(end));
    }
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
      boxes.forEach(function (b) {
        var eh = $('.timer-hours', b), em = $('.timer-minutes', b), es = $('.timer-seconds', b);
        if (eh) eh.textContent = pad(h);
        if (em) em.textContent = pad(m);
        if (es) es.textContent = pad(s % 60);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------- date de mise à jour
     Date glissante à J-2, en français, pour que l'article reste « frais ». */
  function initDate() {
    var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var d = new Date(Date.now() - 2 * 86400000);
    var txt = 'Dernière mise à jour ' + d.getDate() + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear();
    $$('*').forEach(function (el) {
      if (el.children.length) return;
      if (/^Dernière mise à jour /.test((el.textContent || '').trim())) el.textContent = txt;
    });
  }

  function boot() {
    initReveal();
    initSplide();
    initCountdown();
    initDate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
